import { FormField } from 'ui/formField';
import { validateRelativeDate } from 'utils/validateDate';
import { noop } from 'utils/noop';
import BasePanel from './BasePanel';

// type Props = {
//   /** Unparsed relative date value */
//   value: string,
//   /** Callback function when date/time range changes. */
//   onRangeChange: ({}, { value: string }) => void,
// };

export const CustomTextInputPanel = ({ value, onRangeChange = noop, ...props }) => {
  return (
    <BasePanel title="Custom" {...props}>
      <div>
        <FormField
          labelText="Enter a date expression"
          helpText={
            <>
              {'Example: '}
              <span style={{ fontWeight: 'bold' }}>now-7d-3h-14m</span>
              {' would be 7 days, 3 hours, and 14 minutes ago.'}
              <br />
              {'Learn more about '}
              <a
                href={
                  'https://support.iterable.com/hc/en-us/articles/360012688571-Relative-Dates-#example-relative-date-expressions'
                }
                rel="noopener noreferrer"
                target="_blank"
              >
                specifying relative dates
              </a>
              {'.'}
            </>
          }
          errorText="Invalid date expression"
          useErrorText={validateRelativeDate(value)}
        >
          <input
            value={value}
            onChange={({ target }) => {
              onRangeChange({ startRange: target.value, isTextInput: true });
            }}
            placeholder={''}
          />
        </FormField>
      </div>
    </BasePanel>
  );
};
